import React, { FC, useRef } from 'react';
import { useClickOutside } from '../../hooks';
import { ICall } from '../../views/authorized/pages/telephony/types';
import { AudioPlayerWave } from 'components/audio-player-wave';
import { Body, Circle, CloseIcon, Wrapper } from './transcript-curtain.styled';
import { Transcript } from '../transcript';
import { CardWrapper } from '../transcript-common';
import { TranscriptSummary } from '../transcript-summary';

interface Props {
  call: ICall;
  onClose: () => void;
}

export const TranscriptCurtain: FC<Props> = ({ call, onClose }) => {
  const bodyRef = useRef<any>(null);

  useClickOutside(bodyRef, () => onClose());

  return (
    <Wrapper>
      <Circle onClick={() => onClose()}>
        <CloseIcon />
      </Circle>
      <Body ref={bodyRef}>
        <CardWrapper>
          <AudioPlayerWave record_url={call.record_url!} />
        </CardWrapper>
        <TranscriptSummary summary={call.ml_transcription_result!.summary} />
        <Transcript
          data={call.ml_transcription_result!.transcript}
          callId={call.id}
        />
      </Body>
    </Wrapper>
  );
};
